import { ENUM__html_ref_stub } from '@/enums/ENUM__html_ref_stub';
import { DTO__image_size } from '@shared/dto/+image/image_asset_base/DTO__image_size';
import { useCallback, useRef, useState } from 'react';

export function HOOK__get_div_size() {
  const [size, set_size] = useState(DTO__image_size.ZERO.clone());

  const [element, set_element] = useState<HTMLDivElement>(ENUM__html_ref_stub.DIV);
  const ref_resize_observer = useRef<ResizeObserver | null>(null);

  // 2. The callback ref that you pass to your JSX template
  const ref_element__set = useCallback((node: HTMLDivElement | null) => {
    // Save/unsave the raw element node to our internal ref

    if (node) set_element(node);

    // Clean up the previous observer if it exists
    if (ref_resize_observer.current) {
      ref_resize_observer.current.disconnect();
      ref_resize_observer.current = null;
    }

    if (!node) return;

    ref_resize_observer.current = new ResizeObserver(([entry]) => {
      if (!entry) return;

      const { width, height } = entry.contentRect;
      try_set_size(width, height);
    });

    ref_resize_observer.current.observe(node);
  }, []);

  function try_set_size(width: number, height: number) {
    if (width == size.width && height == size.height) return;

    let size_new = new DTO__image_size(width, height);

    set_size(size_new);
  }

  /*
   *
   */

  // 3. Return ref_element alongside the callback ref and sizes
  return {
    ref_element__set, // Use this on your JSX: <div ref={ref_div} />
    div_element: element, // Use this to access the raw element node: ref_element.current
    //
    size,
  };
}
